import { render, staticRenderFns } from "./PendingView.vue?vue&type=template&id=60d92c4a&scoped=true&"
import script from "./PendingView.vue?vue&type=script&lang=js&"
export * from "./PendingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d92c4a",
  null
  
)

export default component.exports